import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressCircleComponent implements OnInit, AfterViewInit {

  @ViewChild('progressCircle', { static: true })
  progressCircleRef: ElementRef<SVGCircleElement>;

  @Input()
  public get size(): 'small' | 'medium' | 'large' {
    return this._size;
  }
  public set size(value: 'small' | 'medium' | 'large') {
    this._size = value;
    this.updateCircle();
  }
  private _size: 'small' | 'medium' | 'large' = 'medium';

  @Input()
  public get progress(): number {
    return this._progress;
  }
  public set progress(value: number) {
    this._progress = value;
    this.updateCircle();
  }
  private _progress = 0;

  strokeWidth = 8;
  diameter = 120;

  constructor(
    private renderer: Renderer2,
    private changeRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.updateCircle();
  }

  updateCircle() {
    // update size
    switch (this.size) {
      case 'small':
        this.strokeWidth = 4;
        this.diameter = 60;
        break;
      case 'medium':
        this.strokeWidth = 8;
        this.diameter = 120;
        break;
      case 'large':
        this.strokeWidth = 16;
        this.diameter = 240;
        break;
    }

    // update fill percentage
    if (this.progressCircleRef) {
      const radius = this.progressCircleRef.nativeElement.r.baseVal.value;
      const circumference = radius * 2 * Math.PI;
      const offset = circumference - (this.progress / 100 * circumference);

      this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDasharray', `${circumference} ${circumference}`);
      this.renderer.setStyle(this.progressCircleRef.nativeElement, 'strokeDashoffset', `${offset}`);
    }

    this.changeRef.markForCheck();
  }

}
